import { render, staticRenderFns } from "./SearchFrom_v3.vue?vue&type=template&id=25f5ffcc&"
import script from "./SearchFrom_v3.vue?vue&type=script&lang=js&"
export * from "./SearchFrom_v3.vue?vue&type=script&lang=js&"
import style0 from "./SearchFrom_v3.vue?vue&type=style&index=0&id=25f5ffcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports